/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ChargeIdEnum = 'DAT-TIB' | 'DAT-VM' | 'DAT-SVM' | 'DAT-RWR' | 'CFS-GIB' | 'HOST-HOURS' | 'SDDC-HOURS' | 'RWR-EDR-CB' | 'RWR-EDR-CS';

export const ChargeIdEnum = {

    DAT_TIB: 'DAT-TIB' as ChargeIdEnum,

    DAT_VM: 'DAT-VM' as ChargeIdEnum,

    DAT_SVM: 'DAT-SVM' as ChargeIdEnum,

    DAT_RWR: 'DAT-RWR' as ChargeIdEnum,

    CFS_GIB: 'CFS-GIB' as ChargeIdEnum,

    HOST_HOURS: 'HOST-HOURS' as ChargeIdEnum,

    SDDC_HOURS: 'SDDC-HOURS' as ChargeIdEnum,

    RWR_EDR_CB: 'RWR-EDR-CB' as ChargeIdEnum,

    RWR_EDR_CS: 'RWR-EDR-CS' as ChargeIdEnum
};

